module.exports = __webpack_public_path__ + "assets/ding.mp3";